import { ObjectDirective } from "vue";

const OnMountedFocus: ObjectDirective = {
    mounted(el) {
        // その要素にフォーカスを当てる
        el.focus()
    }
};

export default OnMountedFocus;